import egro from './egro.json'

export default {
  translation: {
    egro,
  },
}
